const _ = require('lodash');
const buttonId = 'uc-privacy-button';

import { SettingsService } from '../../../services/settings-service';
let privacyButtonTemplate1 = require('./templates/privacy-button-template-1.hbs');
let privacyButtonTemplate12 = require('./templates/privacy-button-template-12.hbs');

export default class PrivacyButtonViewController {
	private privacyCornerModalViewController: any;
	private bannerModal: any;
	private utilityService: any;

	private isVisible: boolean;

	private buttonElement: any;
	private updateView: any;
	private privacyCenterModalViewController: any;

	get settingsService() {
		return this.utilityService.settingsService;
	}

	constructor(
		updateView,
		utilityService,
		privacyCornerModalViewController,
		bannerModal,
		privacyCenterModalViewController
	) {
		this.isVisible = true;
		this.updateView = updateView;
		this.privacyCornerModalViewController = privacyCornerModalViewController;
		this.privacyCenterModalViewController = privacyCenterModalViewController;
		this.bannerModal = bannerModal;
		this.utilityService = utilityService;
	}

	private getHtml() {
		let viewHTML: any = () => { };
		const layoutParams: any = this.getPreparedLayoutParams();
		switch (layoutParams.view) {
		case 'privacy-button-template-1':
		case 'privacy-button-template-8':
		case 'privacy-button-template-11':
			viewHTML = privacyButtonTemplate1;
			break;
		case 'privacy-button-template-12':
			viewHTML = privacyButtonTemplate12;
			break;
		default:
			break;
		}

		return viewHTML({
			modalIsVisible: this.privacyCornerModalViewController.visible,
			bannerIsHidden: !this.settingsService.elementsVisibility.bannerVisible,
			openIcon: this.settingsService.settings.buttonPrivacyOpenIcon,
			closeIcon: this.settingsService.settings.buttonPrivacyCloseIcon,
			location: this.settingsService.settings.buttonDisplayLocation,
			btnColor:
				'#' + this.settingsService.settings.styles.btnPrivacyButtonBgColor,
		});
	}

	private getPreparedLayoutParams() {
		const layouts = SettingsService.layouts;
		const goalLayout = _.find(layouts, {
			name: this.settingsService.settings.layout,
		});

		return {
			view: goalLayout.privacyButtonView,
			//todo
		};
	}

	public initHandling() {
		const self = this;
		if (this.visible) {
			this.buttonElement = document.getElementById(buttonId);
			if (this.buttonElement) {
				this.buttonElement.onclick = () => {
					if (self.settingsService.settings.privacyModal === 1) {
						if (self.privacyCornerModalViewController.visible) {
							self.privacyCornerModalViewController.closeModal();
						} else {
							self.privacyCornerModalViewController.openModal();
						}
					} else {
						self.privacyCenterModalViewController.openModal();
						self.updateView();
					}
				};
			}
		}
	}

	public set visible(_isVisible: boolean) {
		this.isVisible = _isVisible;
	}

	public get visible() {
		return this.settingsService.elementsVisibility.primaryButton;
	}

	public get htmlString(): string {
		if (this.visible) {
			return this.getHtml();
		}
		return '';
	}
}
